module.exports = __webpack_public_path__ + "components/country-flag/static/kw-a61d3a8885687007606fe5d162c7cd47.svg";